import { Drawer } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  DASHBOARD_REST_RESERV_VIEW,
  DASHBOARD_REST_TABLES_INFO_CREATE,
  DASHBOARD_REST_TABLES_INFO_DETAILS,
  DASHBOARD_REST_TABLES_INFO_VIEW,
  DASHBOARD_REST_TABLES_VIEW,
  DASHBOARD_REST_VIEW,
  REST_RESERVATION_CREATE,
  REST_RESERVATION_EDIT,
} from '../../../constants/DashboardConst';
import {
  dashboardSelectedRestaurantSelector,
  selectedHotelSelector,
} from '../../property/propertySlice';
import {
  dashboardViewStateSelector,
  fetchRestaurantDashboardReservationDetails,
  restaurantDashboardReservationsSelector,
  restaurantDashboardReservationTableSelector,
  setDashboardViewState,
} from '../DashboardSlice';
import DashboardReservationsCreate from './dashboard-reservations-create/DashboardReservationsCreate';
import DashboardRestaurantList from './dashboard-restaurant-list/DashboardRestaurantList';
import DashboardRestaurantReservations from './dashboard-restaurant-reservations/DashboardRestaurantReservations';
import TableInfoCreate from './dashboard-restaurant-table-info/table-info-create/TableInfoCreate';
import DashboardRestaurantTableInfoList from './dashboard-restaurant-table-info/table-info-list/DashboardRestaurantTableInfoList';
import TableInfoView from './dashboard-restaurant-table-info/table-info-view/TableInfoView';
import DashboardRestaurantTables from './dashboard-restaurant-tables/DashboardRestaurantTables';
import DashboardRestaurantView from './dashboard-restaurant-view/DashboardRestaurantView';
import { decryptLocalStorage } from '../../../utils/authUtils';

const DashboardRestaurant = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const dashboardViewState = useSelector(dashboardViewStateSelector);
  const allDashboardRestList = useSelector(restaurantDashboardReservationsSelector);
  const selectedRestaurant = useSelector(dashboardSelectedRestaurantSelector);
  const restaurantDashboardReservationTable = useSelector(
    restaurantDashboardReservationTableSelector,
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [state, setState] = useState({
    type: REST_RESERVATION_CREATE,
    status: false,
  });
  const [isFromTables, setIsFromTables] = useState(false);
  const currentFilterFromLocation = location?.state?.status;

  useEffect(() => {
    let isSelectedHotel = selectedHotel || decryptLocalStorage('hotelId');
    if (!isSelectedHotel) {
      history.push('/properties');
    }
  }, [history, selectedHotel]);

  useEffect(() => {
    if (selectedRestaurant)
      dispatch(fetchRestaurantDashboardReservationDetails(selectedRestaurant?.id, selectedHotel));
  }, [selectedRestaurant, selectedHotel, dispatch]);

  const onViewToggle = (type, status, obj, previousObj) => {
    dispatch(
      setDashboardViewState({
        type: type,
        status: status,
        obj: obj,
        previousObj: previousObj || null,
      }),
    );
  };

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case REST_RESERVATION_CREATE:
        return (
          <DashboardReservationsCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id}
            selectedRestaurant={selectedRestaurant}
            showLoader={showLoader}
          />
        );
      case REST_RESERVATION_EDIT:
        return (
          <DashboardReservationsCreate
            toggleDrawer={onDrawerToggle}
            reservation={state.obj}
            restaurantId={selectedRestaurant?.id}
            hotelId={selectedHotel}
            selectedRestaurant={selectedRestaurant}
            showLoader={showLoader}
          />
        );
      case DASHBOARD_REST_TABLES_INFO_CREATE:
        return (
          <TableInfoCreate
            toggleDrawer={onDrawerToggle}
            table={state.obj}
            restaurantId={selectedRestaurant?.id}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case DASHBOARD_REST_VIEW:
        return (
          <DashboardRestaurantView
            obj={dashboardViewState.obj}
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            allDashboardRestList={allDashboardRestList}
          />
        );
      case DASHBOARD_REST_TABLES_VIEW:
        return (
          <DashboardRestaurantTables
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            onDrawerToggle={onDrawerToggle}
            obj={dashboardViewState.obj}
            setIsFromTables={setIsFromTables}
            restaurantId={selectedRestaurant?.id}
            selectedRestaurant={selectedRestaurant}
          />
        );
      case DASHBOARD_REST_RESERV_VIEW:
        return (
          <DashboardRestaurantReservations
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            obj={dashboardViewState.obj}
          />
        );
      case DASHBOARD_REST_TABLES_INFO_VIEW:
        return (
          <DashboardRestaurantTableInfoList
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            obj={dashboardViewState.obj}
            permissions={permissions}
            restaurantDashboardReservationTable={restaurantDashboardReservationTable}
            toggleDrawer={onDrawerToggle}
            restaurantId={selectedRestaurant?.id}
            isFromTables={isFromTables}
            setIsFromTables={setIsFromTables}
            onsetPage={(e) => setPage(e)}
            page={page}
            onsetRowsPerPage={(e) => setRowsPerPage(e)}
            rowsPerPage={rowsPerPage}
          />
        );
      case DASHBOARD_REST_TABLES_INFO_DETAILS:
        return (
          <TableInfoView
            obj={dashboardViewState.obj}
            onViewToggle={onViewToggle}
            previousObj={dashboardViewState.previousObj}
            permissions={permissions}
            toggleDrawer={onDrawerToggle}
            allDashboardRestList={allDashboardRestList}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {dashboardViewState.status && <>{switchViewContent(dashboardViewState)}</>}
      {!dashboardViewState.status && (
        <>
          <DashboardRestaurantList
            key={`${selectedRestaurant?.id || ''}-${allDashboardRestList?.length || 0}`}
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            permissions={permissions}
            allDashboardRestList={allDashboardRestList}
            onsetPage={(e) => setPage(e)}
            page={page}
            onsetRowsPerPage={(e) => setRowsPerPage(e)}
            rowsPerPage={rowsPerPage}
            currentFilterFromLocation={currentFilterFromLocation}
            restaurantId={selectedRestaurant?.id}
          />
        </>
      )}
    </>
  );
};

export default DashboardRestaurant;
